import { CustomerService } from '@core/services/customer.service';
import { ConfigModel } from '../core/interfaces/config';

export class MenuConfig implements ConfigModel {
	public config: any = {};

	constructor() {

		var company = new CustomerService();

		if (company.settings.name != "sef") {

			this.config = {
				header: {
					self: {},
					items: [
						{
							title: 'Actions',
							root: true,
							icon: 'flaticon-add',
							toggle: 'click',
							translate: 'MENU.ACTIONS',
							submenu: {
								type: 'classic',
								alignment: 'left',
								items: [
									{
										title: 'Create New Post',
										page: '/header/actions',
										icon: 'flaticon-file',
										translate: 'MENU.CREATE_POST',
										aside: {
											self: {
												bullet: 'dot'
											},
											items: [
												{
													section: 'Departments'
												},
												{
													title: 'Resources',
													desc: '',
													icon: 'flaticon-layers',
													bullet: 'dot',
													root: true,
													submenu: [
														{
															title: 'Create New Post',
															page: '/header/actions',
														},
														{
															title: 'Timesheet',
															tooltip: 'Non functional dummy link',
														},
														{
															title: 'Payroll',
															tooltip: 'Non functional dummy link',
														},
														{
															title: 'Contacts',
															tooltip: 'Non functional dummy link',
														}
													]
												}
											]
										}
									},
									{
										title: 'Generate Reports',
										tooltip: 'Non functional dummy link',
										icon: 'flaticon-diagram',
										badge: {
											type: 'm-badge--success',
											value: '2'
										},
									},
									{
										title: 'Manage Orders',
										icon: 'flaticon-business',
										submenu: {
											type: 'classic',
											alignment: 'right',
											bullet: 'line',
											items: [
												{
													title: 'Latest Orders',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Pending Orders',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Processed Orders',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Delivery Reports',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Payments',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Customers',
													tooltip: 'Non functional dummy link',
													icon: '',
												}
											]
										}
									},
									{
										title: 'Customer Feedbacks',
										page: '/#',
										icon: 'flaticon-chat-1',
										submenu: {
											type: 'classic',
											alignment: 'right',
											bullet: 'dot',
											items: [
												{
													title: 'Customer Feedbacks',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Supplier Feedbacks',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Reviewed Feedbacks',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Resolved Feedbacks',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Feedback Reports',
													tooltip: 'Non functional dummy link',
													icon: '',
												}
											]
										}
									},
									{
										title: 'Register Member',
										tooltip: 'Non functional dummy link',
										icon: 'flaticon-users',
									}
								]
							}
						}
					]
				},
				aside: {
					self: {},
					items: []
				}
			};
		}
		else{
			this.config = {
				header: {
					self: {},
					items: [
						{
							title: 'Actions',
							root: true,
							icon: 'flaticon-add',
							toggle: 'click',
							translate: 'MENU.ACTIONS',
							submenu: {
								type: 'classic',
								alignment: 'left',
								items: [
									{
										title: 'Create New Post',
										page: '/header/actions',
										icon: 'flaticon-file',
										translate: 'MENU.CREATE_POST',
										aside: {
											self: {
												bullet: 'dot'
											},
											items: [
												{
													section: 'Departments'
												},
												{
													title: 'Resources',
													desc: '',
													icon: 'flaticon-layers',
													bullet: 'dot',
													root: true,
													submenu: [
														{
															title: 'Create New Post',
															page: '/header/actions',
														},
														{
															title: 'Timesheet',
															tooltip: 'Non functional dummy link',
														},
														{
															title: 'Payroll',
															tooltip: 'Non functional dummy link',
														},
														{
															title: 'Contacts',
															tooltip: 'Non functional dummy link',
														}
													]
												}
											]
										}
									},
									{
										title: 'Generate Reports',
										tooltip: 'Non functional dummy link',
										icon: 'flaticon-diagram',
										badge: {
											type: 'm-badge--success',
											value: '2'
										},
									},
									{
										title: 'Manage Orders',
										icon: 'flaticon-business',
										submenu: {
											type: 'classic',
											alignment: 'right',
											bullet: 'line',
											items: [
												{
													title: 'Latest Orders',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Pending Orders',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Processed Orders',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Delivery Reports',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Payments',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Customers',
													tooltip: 'Non functional dummy link',
													icon: '',
												}
											]
										}
									},
									{
										title: 'Customer Feedbacks',
										page: '/#',
										icon: 'flaticon-chat-1',
										submenu: {
											type: 'classic',
											alignment: 'right',
											bullet: 'dot',
											items: [
												{
													title: 'Customer Feedbacks',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Supplier Feedbacks',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Reviewed Feedbacks',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Resolved Feedbacks',
													tooltip: 'Non functional dummy link',
													icon: '',
												},
												{
													title: 'Feedback Reports',
													tooltip: 'Non functional dummy link',
													icon: '',
												}
											]
										}
									},
									{
										title: 'Register Member',
										tooltip: 'Non functional dummy link',
										icon: 'flaticon-users',
									}
								]
							}
						}
					]
				},
				aside: {
					self: {},
					items: []
				}
			};
		}
	}
}
